import LandingLayout from './LandingLayout';
import { Target, Users, Zap, Heart } from 'lucide-react';

export default function About() {
  const values = [
    {
      icon: Target,
      title: 'Our Mission',
      description: 'To empower UK tradespeople with the tools they need to run successful, efficient businesses. We believe every tradesperson deserves professional-grade business management software.',
    },
    {
      icon: Users,
      title: 'Built for Tradespeople',
      description: 'SparxMate was created specifically for UK tradespeople. We understand the unique challenges you face and have built features that address your real-world needs.',
    },
    {
      icon: Zap,
      title: 'Simple & Powerful',
      description: 'We believe software should be easy to use but powerful enough to handle complex business operations. No unnecessary complexity, just the features you need.',
    },
    {
      icon: Heart,
      title: 'Your Success is Our Success',
      description: 'When your business thrives, we succeed. That\'s why we\'re committed to continuously improving SparxMate based on your feedback and needs.',
    },
  ];

  return (
    <LandingLayout>
      {/* Hero */}
      <section className="bg-gradient-to-br from-orange-50 via-white to-orange-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            About SparxMate
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            The business management platform designed specifically for UK tradespeople
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Our Story</h2>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              SparxMate was born from a simple observation: UK tradespeople were struggling with outdated, 
              generic business management tools that didn't understand their specific needs.
            </p>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Whether you're an electrician managing BS7671 certifications, a plumber tracking materials 
              and labour costs, or a general contractor handling multiple clients and suppliers, you need 
              software that speaks your language.
            </p>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              That's why we built SparxMate—a comprehensive platform that combines invoicing, estimates, 
              certification management, client CRM, purchase tracking, financial reporting, and more, all 
              tailored specifically for UK tradespeople.
            </p>
            <p className="text-gray-600 dark:text-gray-400">
              We're committed to making your business operations smoother, more professional, and more 
              profitable. Because when you succeed, we succeed.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4">
              What We Stand For
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div key={index} className="bg-white dark:bg-gray-900 rounded-xl p-8 border border-gray-200 dark:border-gray-700">
                  <div className="inline-flex items-center justify-center h-16 w-16 bg-orange-100 dark:bg-orange-900/30 rounded-xl mb-6">
                    <Icon className="h-8 w-8 text-orange-600 dark:text-orange-500" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-r from-orange-600 to-orange-700 dark:from-orange-700 dark:to-orange-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Ready to Join Us?
          </h2>
          <p className="text-xl text-orange-100 mb-8">
            Start your free trial today and see how SparxMate can transform your business.
          </p>
          <a
            href="/pricing"
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-orange-600 rounded-lg font-semibold text-lg hover:bg-gray-50 transition-colors shadow-lg"
          >
            Get Started Free
          </a>
        </div>
      </section>
    </LandingLayout>
  );
}


